import { detect } from 'detect-browser';

/**
 * Central configuration for Dixa Rewind.
 *
 * This ensures the year is consistent across all components and prevents issues
 * if Rewind is still active when the calendar year changes.
 */
export const rewindConfig = {
  /** The year this Rewind edition covers. */
  year: 2025,
  /** The hashtag for social sharing. */
  hashtag: '#DixaRewind2025',
  /**
   * Detect if browser is Chrome, Firefox, or Edge (copy/save image only works
   * well in these browsers).
   */
  canGenerateImages: ['chrome', 'firefox', 'edge-chromium'].includes(
    detect()?.name ?? '',
  ),
} as const;
